/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import { pageSelector as selectPage } from 'src/selectors/page';
import { PAGE_NAME } from './constants';

const pageSelector = selectPage(PAGE_NAME);

export const validatedPinSelector = createSelector(pageSelector, (page) => page.get('card'));
